export const getSponsorsBookmark = () => {
  try {
    const bookmark = sessionStorage.getItem("bookmark")
    return typeof bookmark === "string" ? new URL(bookmark) : null
  } catch {
    // Just in case the bookmark is not a valid URL
    return null
  }
}

export const setSponsorsBookmark = (bookmark: URL | null) => {
  if (bookmark) {
    sessionStorage.setItem("bookmark", bookmark.toString())
  } else {
    clearSponsorsBookmark()
  }
}

export const clearSponsorsBookmark = () => {
  sessionStorage.removeItem("bookmark")
}
